import React from 'react'
import { splitDinnerServerTips } from '../actions'
import { useDispatch } from 'react-redux';

const SplitDinnerTipsButton = () => {
    const dispatch = useDispatch();
 return <button onClick={() => dispatch(splitDinnerServerTips())}>Split Dinner Tips</button>
 }

export default SplitDinnerTipsButton